import { useContext, useEffect, useState } from "react";
import { BaseAlertModal } from "../../../../components/modal/alert";
import { AppLayout } from "../../../../containers/layout/app";
import { CreateGroupWrapper } from "./styled";
import { AlertModalCheckIcon } from "../../../../assets";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../context/appContext";
import { OnboardGroupAccountFormFieldsType } from "../../../../types/container.type";
import { Box, Typography } from "@mui/material";
import { OnboardGroupAccount } from "../../../../containers/form/onboardgroupaccount";
import { onboardGroupService } from "../../../../utils/api/customerservice/grouplist/onboardGroup";
import Cookies from "universal-cookie";

export const CreateGroup = () => {
	const cookies = new Cookies();
	const TOKEN = cookies.getAll().TOKEN;

	const navigate = useNavigate();
	const { setActiveNavItem } = useContext(AppContext);

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
	const [formDetails, setFormDetails] =
		useState<OnboardGroupAccountFormFieldsType>({
			accountType: " ",
			branch: "",
			name: "",
			registrationType: " ",
			savingsProduct: " ",
			accountManager: " ",
			meetingDay: "",
			meetingTime: "",
			meetingFrequency: " ",
			meetingLocation: "",
			email: "",
			primaryContactName: " ",
			primaryContactPhone: "",
			status: " ",
			mandate: "",
			members: [],
		});

	useEffect(() => {
		setActiveNavItem("Customer Service");
	}, [setActiveNavItem]);

	const handleAlertModalPersist = () => {
		return setIsAlertModalOpen(true);
	};

	const handleAlertModalCallToActionClick = () => {
		setIsAlertModalOpen(false);
		return navigate(-1);
	};

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setError(null);
		setIsLoading(true);
		try {
			const response = await onboardGroupService(TOKEN, formDetails);
			if (response.status === "success") {
				setIsLoading(false);
				setIsAlertModalOpen(true);
			} else {
				setIsLoading(false);
				setError(
					"Failed to create group. Please check credentials and try again."
				);
			}
		} catch (error: any) {
			setIsLoading(false);
			setError(`Group creation failed. ${error.message}`);
			console.error("Group creation failed:", error);
		}
	};

	return (
		<AppLayout pageId={"Group-List"} pageTitle={"Create Group"}>
			<CreateGroupWrapper>
				{/* alert modal below */}
				<BaseAlertModal
					open={isAlertModalOpen}
					icon={<AlertModalCheckIcon />}
					title={`Add Group Account Successful`}
					message="Your information has been successfully added to the system."
					callToAction="Back to Group List"
					handleClose={handleAlertModalPersist}
					handleCallToAction={handleAlertModalCallToActionClick}
				/>
				{/* alert modal above */}
				<Box>
					<Typography
						variant="h3"
						fontFamily={"Poppins"}
						fontWeight={700}
						fontSize={20}
						lineHeight={"normal"}
						color="var(--dark-color)"
					>
						Enter Group Information
					</Typography>
				</Box>
				<OnboardGroupAccount
					error={error}
					isLoading={isLoading}
					handleSubmit={handleSubmit}
					formDetails={formDetails}
					setFormDetails={setFormDetails}
				/>
			</CreateGroupWrapper>
		</AppLayout>
	);
};
